module.exports = __webpack_public_path__ + "static/media/gq_logo_full.333c8b0a.png";